export const allowedTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/jpeg",
  "image/png",
  "application/zip",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "video/mp4",
  "video/quicktime",
];
export const isValidFileType = (file) => {
  const allowedMimeTypes = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/zip",
    "application/x-zip",
    "application/x-zip-compressed",
    "application/octet-stream",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.ms-powerpoint",
    "video/mp4",
    "video/quicktime",
  ];

  const allowedExtensions = [
    ".pdf",
    ".docx",
    ".doc",
    ".xlsx",
    ".xls",
    ".jpg",
    ".jpeg",
    ".png",
    ".zip",
    ".ppt",
    ".pptx",
    ".mp4",
    ".mov",
  ];

  const fileName = file.name.toLowerCase();
  const fileExtension = fileName.substring(fileName.lastIndexOf("."));

  // Check if file has valid MIME type OR valid extension
  const hasValidMimeType = allowedMimeTypes.includes(file.type);
  const hasValidExtension = allowedExtensions.includes(fileExtension);

  // Special handling for ZIP files - if extension is .zip, allow it regardless of MIME type
  if (fileExtension === ".zip") {
    return true;
  }

  return hasValidMimeType || hasValidExtension;
};
